import { forwardRef } from 'react';

import { CompareIcon } from '@src/shared/ui/icons';
import IconButton, { type ExtendedIconButtonProps } from './IconButton';

const CompareIconButton = forwardRef<HTMLButtonElement, ExtendedIconButtonProps>(
  (props, ref) => {
    return (
      <IconButton
        ref={ref}
        {...props}
      >
        <CompareIcon color="inherit" />
      </IconButton>
    );
  },
);

CompareIconButton.displayName = 'CompareIconButton';
export default CompareIconButton;
